<div class='checkout mt-5 mb-5'>
    <div *ngIf="error" class="container">
        <app-errormessage
            [serverErrorMessage]="error.message"
            [errorMessageTranslationKey]="error.localizationKey">
        </app-errormessage>
    </div>


    <div class='card col-md-8 offset-md-2 col-xl-6 offset-xl-3 mb-4'>
        <div class="row">
            <div class="card-header">
                <h2 class="card-title"><span [appTranslate]="'PaypalPaymentGatewayPageTitle'">Bestellung</span></h2>
            </div>
            <div class="card-body">
                <div *ngIf="!registrationInProgress" class="container">
                    <div class="row">
                        <div class="col-12 col-md-6 p-2">
                            <h3 class="h4" [appTranslate]="'OrderSummary'">Order Summary</h3>
                            <b [appTranslate]="'Description'">Description:</b> Event pass<br>
                            <b [appTranslate]="'Amount'">Amount:</b> {{ currencyCode }} {{ total | number:'.2-2' }}
                        </div>
                    </div>
                </div>
                <div *ngIf="registrationInProgress" class="full-size-spinner-container p-5">
                    <app-spinner></app-spinner>
                </div>
            </div>

            <div class="card-footer">
                <div class='payment-actions'>
                    <div>
                        <button (click)="cancel()" class='btn btn-secondary btn-lg'>
                            <span [appTranslate]="'CancelPayment'">Cancel Payment</span>
                        </button>
                    </div>
                    <div #paypal></div>
                </div>
            </div>
        </div>
    </div>
</div>
